import { aroFetch } from "../aroApi";
import { PersonDetail, PersonListItem, PersonListResponse, PersonSearchParams, PersonTracking, TrackingStatus } from "../../types/aro";

export async function fetchPersons(params: PersonSearchParams): Promise<PersonListResponse> {
  const qs = new URLSearchParams();
  if (params.name)                                                qs.set("name",             params.name);
  if (params.email)                                               qs.set("email",            params.email);
  if (params.certificate_name)                                    qs.set("certificate_name", params.certificate_name);
  if (params.event_id)                                            qs.set("event_id",         params.event_id);
  if (params.highest_level && params.highest_level !== "all")     qs.set("highest_level",    params.highest_level);
  if (params.no_linkedin)                                         qs.set("no_linkedin",      "true");
  qs.set("limit",  String(params.limit  ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return aroFetch<PersonListResponse>(`/api/persons?${qs.toString()}`);
}

export async function fetchPersonById(id: string | number): Promise<PersonDetail> {
  return aroFetch<PersonDetail>(`/api/persons/${id}`);
}

export async function updatePerson(
  id: string | number,
  fields: { full_name?: string; linkedin_url?: string },
  changed_by: string
): Promise<PersonListItem> {
  return aroFetch<PersonListItem>(`/api/persons/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ ...fields, changed_by }),
  });
}

/** Admin edit of a person's tracking. Setting status "active" also clears the reason and resets failures. */
export interface PersonTrackingPatch {
  status?:               TrackingStatus;
  status_reason?:        string | null;
  tracking_end_date?:    string;
  next_scrape_due?:      string;
  baseline_company?:     string | null;
  baseline_company_url?: string | null;
  changed_company?:      string | null;
  changed_company_url?:  string | null;
}

export async function updatePersonTracking(
  id: string | number,
  fields: PersonTrackingPatch,
  changed_by: string
): Promise<PersonTracking> {
  return aroFetch<PersonTracking>(`/api/persons/${id}/tracking`, {
    method: "PATCH",
    body: JSON.stringify({ ...fields, changed_by }),
  });
}
